import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const pageMap = {
  lesson1: `${process.env.PUBLIC_URL}/lesson1.html`,
  lesson2: `${process.env.PUBLIC_URL}/lesson2.html`,
  lesson3: `${process.env.PUBLIC_URL}/lesson3.html`,
};

const useStylesForTab = makeStyles({
  root: (props) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 44,
    marginTop: 4,
    backgroundColor: props.page === props.currentPage ? "#dff3fc" : "#9ad9fc",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    fontSize: "1.4rem",
    cursor: "pointer",
  }),
});

function Tab(props) {
  const { page, children } = props;
  const classes = useStylesForTab(props);

  const handleChange = () => {
    window.location.href = pageMap[page];
  };

  return (
    <div className={classes.root} onClick={handleChange}>
      {children}
    </div>
  );
}

const useStylesForTabs = makeStyles((theme) => ({
  root: {
    display: "grid",
    columnGap: 8,
    gridTemplateColumns: "auto auto auto",
  },
}));

function Tabs(props) {
  const { currentPage } = props;
  const classes = useStylesForTabs();

  return (
    <div className={classes.root}>
      <Tab page="lesson1" currentPage={currentPage}>
        けんばんをひこう
      </Tab>
      <Tab page="lesson2" currentPage={currentPage}>
        リズムをつくろう
      </Tab>
      <Tab page="lesson3" currentPage={currentPage}>
        がっそうしよう
      </Tab>
    </div>
  );
}

export default Tabs;
